import { render } from "./UserNavigation.vue?vue&type=template&id=7e585181&scoped=true"
import script from "./UserNavigation.vue?vue&type=script&lang=js"
export * from "./UserNavigation.vue?vue&type=script&lang=js"

import "./UserNavigation.vue?vue&type=style&index=0&id=7e585181&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e585181"]])

export default __exports__